import { ICarbonOffsetImpact, IImpactData, IMoneyImpact } from "./impact";

export interface ISustainableDevelopmentGoal {
    goalNum: string;
    imageUrl: string;
    description: string;
    title: string;
}

export interface FilterOptions {
    regions: string,
    methodCategory: string,
    registry: string,
    searchTerm: string,
    statuses: string[];
}

export type Project = {
    carbonOffsetImpact: ICarbonOffsetImpact;
    code: string;
    externalUrl?: string;
    id: string;
    images?: string[];
    imgUrl?: string | null;
    latitude: number;
    locationDescription: string;
    inventoryId: string;
    inventoryOurReference: string;
    longDescription?: string;
    longitude: number;
    name: string;
    portion: number;
    shortDescription: string;
    thumbnailImageUrl: string;
    type: 'MONEY' | 'CARBON' | string;
    projectHighlights?: {
        description: string;
        displayOrder: number;
    }[];
    supplier?: {
        code: string;
        description: string;
        logoUrl: string;
    };
    sustainableDevelopmentGoals?: ISustainableDevelopmentGoal[];
    url?: string;
    registry?: {
        name: string;
        imageUrl?: string;
    },
    impact?: IImpactData;
    method?: string;
    mitigationType?: string;
    media?: {
        displayOrder: number;
        type: string;
        url: string;
    }[];
    estimatedUnitPrice?: {
        price: IMoneyImpact;
        unit: string;
    };
    status?: 'INACTIVE' | 'PRIVATE' | 'PUBLISHED' | 'ACTIVE';
    productType: string;
    numberOfContributions: {
        value: number;
    },
    vintage?: string;
    netAmount?: IMoneyImpact;
    maximumAvailableForPurchase: CarbonOffset;
    regions?: string[];
    methodCategory?: string;
    externalId?: string;
}

export type CarbonOffset = {
    unit: string,
    value: number
}

export interface ProjectFilterOptions {
    regions: string;
    methodCategory: string;
    registry: string;
    searchTerm: string;
    goalNums: {
        label: string;
        value: string
    }[];
}

export type Basket = {
    code: string;
    displayName: string;
    externalUrl: string;
    id: string;
    name: string;
    sdgCount: number;
    shortDescription: string;
    thumbnailImageUrl: string;
    projects: Project[];
    estimatedUnitPrice?: {
        price: IMoneyImpact;
        unit: string;
    };
    maximumAvailableForPurchase: CarbonOffset;
}

export enum CART_STEPS {
    CREDITS = 0,
    PAYMENT = 1,
    CONFIRMATION = 2,
}

export type Product = ((Basket | Project) & {
    selectedAmount?: {
        value: number;
        unit: string;
    }
});

export const checkIsProject = (obj: Product): obj is Project => {
    if (!obj) return false;
    return !!Object.hasOwnProperty.call(obj, 'method')
        || !!Object.hasOwnProperty.call(obj, 'registry')
}
